import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PersonPointService } from 'app/services/models/person-point.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { link } from 'fs';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-worker',
  templateUrl: './update-worker.component.html',
  styleUrls: ['./update-worker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateWorkerComponent implements OnInit {
  public contentHeader: object;
  personForm: FormGroup;

  person: any = {};
  personId: number;
  companies: any;
  isUpdate: any = true;

  birthDate: Date = null
  startDate: Date = null;
  leaveDate: Date = null;

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeLeaveJobOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,

  };

  constructor(
    private activatedRouter: ActivatedRoute,
    private personService: PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private personPointService: PersonPointService
  ) {}

  async ngOnInit() {
    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null, Validators.required],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      birthDay: [null],
      startDate: [null],
      workingStatus: [null],
      department: [null],
      emergencyContact: [null],
      tc: [null, [Validators.required, Validators.maxLength(11)]],
      wage: [null, Validators.min(0)],
      leaveJob: [null],
      workingDays:[null,[Validators.min(1), Validators.max(7)]],
      workingDayHours:[null,[Validators.min(1), Validators.max(24)]]
    });
    this.contentHeader = {
      headerTitle: 'Personel',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Personel Listesi',
            link: '/admin/person',
            isLink: true,
          },
          {
            name: 'Personel Güncelle',
            isLink: false,
          },
        ]
      }
    }
    this.personService.event$.subscribe(async result => {
      this.activatedRouter.params.subscribe(async params => {
        console.log(params);
        this.personId = params['id'];
        await this.getByIdWorker(params['id'])
      });
    })
    this.activatedRouter.params.subscribe(async params => {
      console.log(params);
      this.personId = params['id'];
      await this.getByIdWorker(params['id'])
    });
  }



  async getByIdWorker(id) {
    const data = await this.personService.getByIdWorker(id);
    console.log(data);
    this.person = data;
    if (this.person != null) {
      this.personForm.patchValue({
        name: this.person.name,
        lastName: this.person.lastName,
        mission: this.person.mission,
        phoneNumber: this.person.phoneNumber,
        mail: this.person.mail,
        address: this.person.address,
        birthDay: this.person.personalAdditionalInfarmation?.birthDay,
        startDate: this.person.personalAdditionalInfarmation?.startDate,
        workingStatus: this.person.personalAdditionalInfarmation?.workingStatus,
        department: this.person.personalAdditionalInfarmation?.department,
        emergencyContact: this.person.personalAdditionalInfarmation?.emergencyContact,
        tc: this.person.personalAdditionalInfarmation?.tc,
        wage: this.person.personalAdditionalInfarmation?.wage,
        leaveJob: this.person.personalAdditionalInfarmation?.leaveJob,
        workingDays:this.person.personalAdditionalInfarmation?.workingDays,
        workingDayHours:this.person.personalAdditionalInfarmation?.workingDayHours
      });

      this.birthDate = new Date(this.personForm.value.birthDay);
      this.startDate = new Date(this.personForm.value.startDate);
      this.leaveDate = new Date(this.personForm.value.leaveJob);
    }
    await this.calculatePersonPoints(id);
  }

  updateChange() {
    this.isUpdate = !this.isUpdate;
  }

  calculate: any;

  async calculatePersonPoints(id) {
    const response = await this.personPointService.calculatePersonPoints(id);
    console.log(response);
    this.calculate = response;
  }

  async onSumbit() {
    if (this.personForm.valid) {
      console.log(this.personForm.value);

      const formData = this.personForm.value;

      // `updateWorker` metodu için uygun veri formatını hazırlıyoruz
      const workerData = {
        id: this.person.id, // Eğer formda id yoksa varsayılan olarak 0 kullanılır
        name: formData.name,
        lastName: formData.lastName,
        mission: formData.mission,
        phoneNumber: formData.phoneNumber,
        mail: formData.mail,
        address: formData.address,
        companyId: 1, // Eğer formda companyId yoksa varsayılan olarak 0 kullanılır
        updatePersonalAdditionalInfarmation: {
          id: this.person.personalAdditionalInfarmation?.id ?? 0, // Varsayılan id değeri
          tc: formData.tc,
          birthDay: new Date(formData.birthDay[0]), // Tarih array içinden çekilir
          startDate: new Date(formData.startDate[0]), // Tarih array içinden çekilir
          department: formData.department,
          workingStatus: formData.workingStatus,
          wage: formData.wage,
          emergencyContact: formData.emergencyContact,
          personId: this.person.id, // Varsayılan personId değeri,
          leaveJob: new Date(formData.leaveJob[0]),
          workingDays:formData.workingDays,
          workingDayHours:formData.workingDayHours
        },
      };
      console.log(workerData);
      const response = await this.personService.updateWorker(workerData);
      console.log(response);
      if (response.status == true) {
        this.updateChange();
        this.personService.sendEvent(true);
        this.toastrService.success(response.message);
      } else {
        this.toastrService.error(response.message);
      }
    }
  }
}